export const URL_TYPES = {
  CORE_DOMAIN: "core-domain",
  FQDN: "fqdn",
  HOST_PATH: "host-path",
  NAKED_HOST_PATH: "naked-host-path",
  PUBLIC_SUFFIX: "public-suffix"
};
